
<div class="how-it-work" [class.arebic-content]="textDirection == 'rtl'">
    <div class="how-it-works">
        <div class="arrow">
            <div>
                <h4 class="title" translate>HOME_PAGE.HOW_TALY_WORK</h4><br>
                <h4 class="title" translate>HOME_PAGE.TRY_OUR_CALCULATOR</h4>
            </div>
            
                <img src="assets/images/arrow-icon.svg" alt="">
            
          
        </div>

        <!-- <p translate>HOME_PAGE.HOW_TALY_DESC</p> -->
    </div>
    <div class="try-our-calc">
        <h4 class="title" translate>HOME_PAGE.TRY_OUR</h4>
    </div>
    <div class="range-slider">
        <div class="slider-amount">
            <span translate>HOME_PAGE.DESIRE_AMOUNT</span>
            <h4> {{ 'KWD' | translate}} {{amountCtrl.value}}</h4>
            <p-slider name="sliderValue" [formControl]="amountCtrl"  [min]="0" [max]="500"></p-slider>
        </div>
        <div class="slider-installment">
            <taly-instalments   [isLightTheam]="false" [amounts]="amountCtrl?.value" />
        </div>
    </div>

</div>